// extracted by mini-css-extract-plugin
export default {"page":"AY-z","cartModal":"BY-z","checkout":"CY-z","placeholder":"DY-z","account":"EY-z"};